(function (root, factory) {
    if (typeof module === "object" && module.exports) {
        module.exports = factory(root);
    } else if (typeof define === 'function' && define.amd) {
        define('escroll',[], function () {
            return factory(root)
        });
    } else {
        root.EasyScroll = factory(root);
    }
})(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this, function (window) {

    var animationFrame = (function () {
        return window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRquestAnimationFrame ||
            function (fn) {
                return window.setTimeout(function () {
                    fn(Date.now())
                }, 20)
            }
    })()

    var animationFrameCancel = (function () {
        return window.cancelAnimationFrame ||
            window.webkitCancelAnimationFrame ||
            window.mozCancelAnimationFrame ||
            window.oCancelAnimationFrame ||
            window.msCancelAnimationFrame ||
            clearTimeout
    })();


    var getIncByTimeFn = function (setting, time) {
        var pattern = 0;
        if (setting == 'ease-in-out') pattern = time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1;
        if (setting == 'ease-in') pattern = time * time;
        if (setting == 'ease-out') pattern = time * (2 - time);
        return pattern || time;
    }

    var getSuitableSrollFn = function (elm) {
        return 'scrollTo' in elm &&
            function (position) {
                elm.scrollTo(0, position)
            } ||
            function (position) {
                elm.scrollTop = position
            }
    }


    var excuteAnimaFrame = function (ins, cb) {
        var start
        var timeInterval = 0
        var percentage
        var that = ins

        var startScroll = function (timestamp) {
            if (!start) {
                start = timestamp
            }

            timeInterval += timestamp - start
            percentage = timeInterval / that.duration
            percentage = percentage > 1 ? 1 : percentage

            /**@return {Boolean}  true 表示动画帧继续 false 代表动画执行结束*/
            if (cb(percentage)) {
                that.frameId = animationFrame(startScroll)
                start = timestamp
            } else {
                animationFrameCancel(that.frameId)
            }
        }

        that.frameId = animationFrame(startScroll)
    }


    var getTopWrapper = function () {
        var body = document.body
        var html = document.documentElement
        var UA = navigator.userAgent

        /**
         * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
         *
         * @type boolean
         */
        var deviceIsWindowsPhone = UA.indexOf("Windows Phone") >= 0;

        /**
         * Android requires exceptions.
         *
         * @type boolean
         */
        var deviceIsAndroid = UA.indexOf('Android') > 0 && !deviceIsWindowsPhone;


        /**
         * iOS requires exceptions.
         *
         * @type boolean
         */
        var deviceIsIOS = /iP(ad|hone|od)/.test(UA) && !deviceIsWindowsPhone;

        /**
         * BlackBerry requires exceptions.
         * 
         * @type boolean
         */
        var deviceIsBlackBerry10 = UA.indexOf('BB10') > 0;

        //移动端的html的scrollTop永远都是0, so...
        if (deviceIsWindowsPhone || deviceIsAndroid || deviceIsIOS || deviceIsBlackBerry10) {
            return body
        }

        //PC兼容DTC模式
        return html.scrollTop >= body.scrollTop ? html : body
    }


    var handleElemError = function (i) {
        var mapNums = ['', '1st', '2nd', '3rd', '4th']
        throw new TypeError('The ' + mapNums[i] + ' argument must be a valid query string or HTMLElement');
    }

    /**
     * 获取元素到容器的顶部距离
     * @param {Element} el 
     */
    var getOffsetTop = function (el, container) {
        var accOffsetTop = 0
        var domBody = document.body

        while (el && (container !== el || el !== domBody)) {
            accOffsetTop += el.offsetTop
            el = el.offsetParent
        }

        return accOffsetTop;
    }


    var EasyScroll = function (el, duration, timeFn) {
        this.el = typeof el === 'string' && document.querySelector(el) || el || getTopWrapper()

        if (!this.el) {
            handleElemError(1)
        }

        this.duration = duration || 500
        this.timeFn = timeFn || 'ease-in-out'
        this.frameId = null
        this.scrollTo = getSuitableSrollFn(this.el)
    }


    EasyScroll.prototype.scrollToTop = function () {
        var that = this
        var distance = that.el.scrollTop
        var position
        var scrollTo = that.scrollTo
        var timeFn = that.timeFn

        excuteAnimaFrame(that, function (percentage) {
            position = (1 - getIncByTimeFn(timeFn, percentage)) * distance
            scrollTo(Math.floor(position))
            return position > 0
        })
    }

    EasyScroll.prototype.scrollToBottom = function () {
        var that = this
        var elm = that.el

        var maxScrollDis = elm.scrollHeight - elm.clientHeight
        if (maxScrollDis <= 0) return;

        var scrollTop = elm.scrollTop
        var timeFn = that.timeFn
        var position
        var scrollTo = that.scrollTo

        excuteAnimaFrame(that, function (percentage) {
            position = scrollTop + getIncByTimeFn(timeFn, percentage) * (maxScrollDis - scrollTop)
            scrollTo(Math.floor(position))
            return position < maxScrollDis
        })
    }


    EasyScroll.prototype.scrollToElement = function (to, fixed) {
        var target = typeof to === 'string' && document.querySelector(to) || to

        if (!target) {
            handleElemError(1)
        }

        var fixedDis = fixed || 0
        var container = this.el
        var targetFixedOffsetTop = getOffsetTop(target, container) - fixedDis
        var scrollTo = this.scrollTo
        var timeFn = this.timeFn
        var contianerScrollTop = container.scrollTop
        var position
        var flag
        var enhance
        var gap

        excuteAnimaFrame(this, function (percentage) {
            enhance = getIncByTimeFn(timeFn, percentage)

            if (contianerScrollTop > targetFixedOffsetTop) {
                //往上拉
                gap = contianerScrollTop - targetFixedOffsetTop
                position = contianerScrollTop - gap * enhance
                flag = position > (contianerScrollTop - gap)
            } else {
                //往下拉
                gap = targetFixedOffsetTop - contianerScrollTop
                position = contianerScrollTop + gap * enhance
                flag = position < (contianerScrollTop + gap)
            }

            scrollTo(Math.floor(position))

            return flag
        })

    }

    return EasyScroll
});
